import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="auth">
      <div className="auth-card" style={{ textAlign: "center" }}>
        <h1 style={{ fontSize: "44px", marginBottom: "12px" }}>۴۰۴</h1>
        <p style={{ color: "var(--ink-500)", marginBottom: "24px" }}>
          صفحه‌ای که دنبال آن بودید پیدا نشد.
        </p>
        <Link className="btn btn-primary" to="/">
          بازگشت به صفحه اصلی
        </Link>
      </div>
    </div>
  );
}
